import { Factory } from '../../SmartContract/Factory.jsx';
import Swal from 'sweetalert2';
import { sanitizeBigInt } from '../FileUploadBlockchain';
import { recarregarContract } from '../FileUploadBlockchain';
import { recarregarTela } from '../FileUploadBlockchain';
import { blockchainService } from '../../../../services/blockchainService.js';

export const criarContract = async (
  project_id,
  modelo_GUID,
  setData2,
  projetoId,
  setFileManagerContract,
  setContractAddressDeploy,
  setContractAddressClient,
  setContractWalletOwner,
  setContractProjectName,
  setContractProjectOwner,
  setContractCar,
  setContractCnpjCpf
) => {
  console.log('🚀 Iniciando criarContract...');
  console.log('📋 Parâmetros recebidos:', {
    project_id,
    modelo_GUID,
    projetoId
  });
  
  if (!projetoId) {
    console.error("❌ Project ID is required");
    Swal.fire({
      title: 'Erro!',
      text: 'Projeto não informado. Recarregue a página e tente novamente.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
    return false;
  }

  const atualizarJsonResponseContract = async (fileManagerContractId, novoJsonResponse, ContratoAddress, ContratoClienteAddress,
    SignerGeral, signature, hashedMessage
  ) => {
    try {
      const payload = sanitizeBigInt({
        json_response: novoJsonResponse,
        ContratoAddress,
        ContratoClienteAddress,
        SignerGeral,
        signature,
        hashedMessage
      });

      const token = sessionStorage.getItem('Authorization');
      const headers = { Authorization: `Bearer ${token}` };

      return await blockchainService.updateContractJsonResponse(fileManagerContractId, payload, headers);
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response:', error.response ? error.response.data : error.message);
      throw error;
    }
  };

  const atualizarData2Contract = async (novoJsonResponse) => {
    try {
      console.log('📤 Enviando dados para save_smart_contract_data2:', novoJsonResponse);
      
      const token = sessionStorage.getItem('Authorization');
      const headers = { Authorization: `Bearer ${token}` };

      console.log('🔄 Fazendo requisição POST para save_smart_contract_data2...');
      const result = await blockchainService.saveSmartContractData2(novoJsonResponse, headers);
      console.log('✅ save_smart_contract_data2 retornou:', result);
      
      return result;
    } catch (error) {
      console.error('❌ Erro ao atualizar JSON response em data2:', error);
      console.error('Detalhes do erro:', error.response ? error.response.data : error.message);
      throw error;
    }
  };

  const atualizaCampoErroContract = async (fileManagerContractId, Signer, signature, hashedMessage, jsonErrorResponse) => {
    try {
      const token = sessionStorage.getItem('Authorization');
      const headers = { Authorization: `Bearer ${token}` };

      return await blockchainService.updateContractJsonErrorResponse(
        fileManagerContractId,
        Signer,
        signature,
        hashedMessage,
        jsonErrorResponse,
        headers
      );
    } catch (error) {
      console.error('❌ Erro ao atualizar campo erro JSON response:', error);
      throw error;
    }
  };

  try {
    const confirmacao = await Swal.fire({
      title: 'Confirmação',
      text: 'Você realmente deseja criar o contrato?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacao.isConfirmed) {
      console.log('❌ Usuário cancelou a criação do contrato');
      return false;
    }

    const token = sessionStorage.getItem('Authorization');
    const headers = { Authorization: `Bearer ${token}` };

    // 1️⃣ Buscar informações do projeto
    console.log('🔍 1️⃣ Buscando informações do projeto...');
    let response;
    try {
      response = await blockchainService.getProjectInfo(project_id, headers);
      console.log('✅ Resposta da API:', response);
      console.log('📊 Estrutura completa da resposta:', JSON.stringify(response, null, 2));
      
      if (!response || !response.success) {
        throw new Error(response?.error || 'Resposta inválida da API getProjectInfo');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar informações do projeto:', error);
      Swal.fire({
        title: 'Erro!',
        text: 'Não foi possível obter informações do projeto: ' + error.message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return false;
    }

    // A API retorna {success: true, data: {...}}
    const info = response.data;
    
    if (!info) {
      console.error('❌ Informações do projeto não encontradas');
      Swal.fire({
        title: 'Erro!',
        text: 'Informações do projeto não encontradas',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return false;
    }

    console.log('📋 Estrutura dos dados recebidos:', Object.keys(info));
    console.log('📊 Dados completos recebidos:', info);

    // Extrair dados do projeto
    let nomePropriedade = '';
    let nomeProprietario = '';
    let cnpjcpf = '';
    let carCodes = [];
    
    // ESTRUTURA CORRETA: info já é o objeto 'data' da resposta
    if (info.project && info.user) {
      console.log('✅ Usando estrutura com project e user');
      
      nomePropriedade = info.project.title || '';
      nomeProprietario = info.user.owner_name || '';
      cnpjcpf = info.user.ProjectCnpjCpf || info.user.owner_cnpj || info.user.owner_cpf || '';
      
      // Obter códigos CAR - ProjectCAR é array; car_codes é fallback legado
      if (info.ProjectCAR && Array.isArray(info.ProjectCAR)) {
        carCodes = info.ProjectCAR;
      } else if (info.car_codes && Array.isArray(info.car_codes)) {
        carCodes = info.car_codes;
      }
      if (carCodes.length > 0) console.log('📋 Códigos CAR encontrados:', carCodes);
      
    } else if (info.title) {
      // Estrutura alternativa (fallback)
      console.log('⚠️ Usando estrutura alternativa');
      nomePropriedade = info.title;
      nomeProprietario = info.owner_name || '';
      cnpjcpf = info.ProjectCnpjCpf || '';
      
      if (info.ProjectCAR && Array.isArray(info.ProjectCAR)) {
        carCodes = info.ProjectCAR;
      } else if (info.car_codes && Array.isArray(info.car_codes)) {
        carCodes = info.car_codes;
      } else if (info.sicar_code) {
        carCodes = [info.sicar_code];
      } else if (info.car) {
        carCodes = [info.car];
      }
      
    } else {
      console.error('❌ Estrutura desconhecida da resposta:', info);
      Swal.fire({
        title: 'Erro!',
        text: 'Estrutura de dados do projeto desconhecida',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return false;
    }

    console.log('📋 Dados extraídos:', {
      nomePropriedade,
      nomeProprietario,
      cnpjcpf,
      carCodes,
      carCount: carCodes.length
    });

    // Validar dados obrigatórios
    const camposObrigatorios = {
      nomePropriedade: !!nomePropriedade,
      nomeProprietario: !!nomeProprietario,
      cnpjcpf: !!cnpjcpf
    };
    
    const camposFaltantes = Object.keys(camposObrigatorios).filter(key => !camposObrigatorios[key]);
    
    if (camposFaltantes.length > 0) {
      console.error('❌ Dados incompletos:', camposObrigatorios);
      Swal.fire({
        title: 'Erro!',
        text: `Dados do projeto incompletos. Faltam: ${camposFaltantes.join(', ')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return false;
    }

    // Verificar se temos códigos CAR
    if (!carCodes || carCodes.length === 0) {
      console.warn('⚠️ Nenhum código CAR encontrado');
      
      const confirmNoCar = await Swal.fire({
        title: 'Atenção!',
        html: `
          <div style="text-align: left;">
            <p><strong>Nenhum código CAR encontrado para este projeto.</strong></p>
            ${info.statistics?.total_guardian_areas ? `<p>Foram verificadas ${info.statistics.total_guardian_areas} Guardian Areas.</p>` : ''}
            <p>Deseja continuar sem código CAR?</p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar sem CAR',
        cancelButtonText: 'Cancelar',
      });
      
      if (!confirmNoCar.isConfirmed) {
        console.log('❌ Usuário cancelou por falta de código CAR');
        return false;
      }
      
      console.log('⚠️ Continuando sem código CAR');
    }

    // Se temos múltiplos CARs, mostrar confirmação
    if (carCodes.length > 1) {
      const confirmCarList = await Swal.fire({
        title: `Múltiplos Códigos CAR Encontrados (${carCodes.length})`,
        html: `
          <div style="text-align: left; max-height: 300px; overflow-y: auto;">
            <p><strong>Os seguintes códigos CAR serão incluídos no contrato:</strong></p>
            <ul style="list-style-type: disc; padding-left: 20px;">
              ${carCodes.map(car => `<li style="margin-bottom: 5px;"><code>${car}</code></li>`).join('')}
            </ul>
            <p>Deseja continuar?</p>
          </div>
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        width: '600px'
      });
      
      if (!confirmCarList.isConfirmed) {
        console.log('❌ Usuário cancelou ao ver múltiplos CARs');
        return false;
      }
    }

    // Preparar dados para o FileManager
    // ProjectCAR é sempre array de strings (múltiplos códigos CAR)
    const requestData = {
      project: project_id,
      ProjectName: nomePropriedade,
      ProjectOwner: nomeProprietario,
      ProjectCnpjCpf: cnpjcpf,
      ProjectCAR: carCodes // Array de códigos CAR
    };

    console.log('📤 Dados para FileManager:', requestData);

    let file_manager_contract_id;

    // 2️⃣ Inserir contrato no FileManager
    try {
      console.log('📝 2️⃣ Inserindo contrato no FileManager...');
      const insertedContract = await blockchainService.insertFileManagerContract(requestData, headers);
      file_manager_contract_id = insertedContract.id;
      console.log('✅ Contrato inserido no FileManager, ID:', file_manager_contract_id);
      console.log('📋 Detalhes do contrato inserido:', insertedContract);
      
    } catch (error) {
      console.error('❌ Erro ao inserir contrato:', error);
      console.error('Detalhes do erro:', error.response?.data);

      const data = error.response?.data;
      const is400ContractExists =
        error.response?.status === 400 &&
        data &&
        typeof data.error === 'string' &&
        data.error.toLowerCase().includes('já existe um contrato');

      if (is400ContractExists && data) {
        const existingId =
          data.id ||
          data.file_manager_contract_id ||
          (data.contract && data.contract.id) ||
          (data.existing_contract && data.existing_contract.id);
        const fieldsToShow = { ...data };
        delete fieldsToShow.error;
        const dataHtml =
          Object.keys(fieldsToShow).length > 0
            ? `<div style="text-align: left; max-height: 320px; overflow-y: auto; margin-top: 12px;">
                <p style="margin-bottom: 8px;"><strong>Dados do contrato existente (retornados pelo servidor):</strong></p>
                <pre style="background: var(--surface-2); padding: 12px; border-radius: 8px; font-size: 12px; white-space: pre-wrap; word-break: break-all;">${JSON.stringify(fieldsToShow, null, 2)}</pre>
                <p style="margin-top: 12px;">Deseja confirmar e continuar usando este contrato para registrar na blockchain (Factory)?</p>
               </div>`
            : `<p style="margin-top: 12px;">Deseja confirmar e continuar usando este contrato para registrar na blockchain (Factory)?</p>`;

        const confirm = await Swal.fire({
          title: 'Contrato já existe',
          html: `<p><strong>${data.error || 'Já existe um contrato com os mesmos códigos CAR para este projeto.'}</strong></p>${dataHtml}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, continuar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: 'var(--accent)',
          width: '560px',
        });

        if (confirm.isConfirmed && existingId) {
          file_manager_contract_id = existingId;
          console.log('✅ Usando contrato existente, ID:', file_manager_contract_id);
        } else {
          if (!confirm.isConfirmed) {
            Swal.fire({
              title: 'Cancelado',
              text: 'Operação cancelada.',
              icon: 'info',
              confirmButtonText: 'OK',
            });
          } else {
            Swal.fire({
              title: 'Erro',
              text: 'Resposta do servidor incompleta: contrato existente não identificado.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
          return false;
        }
      } else {
        let errorMessage = 'Erro ao enviar os dados do contrato.';
        if (data?.error) errorMessage = data.error;
        else if (error.message) errorMessage = error.message;
        Swal.fire({
          title: 'Erro!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK',
        });
        return false;
      }
    }

    // 3️⃣ Gerar e atualizar Smart Contract via Factory
    try {
      console.log('🏭 3️⃣ Chamando Factory...');
      
      const retorno = await Factory(
        nomePropriedade, 
        nomeProprietario, 
        cnpjcpf, 
        carCodes,
        file_manager_contract_id
      );
      
      console.log('✅ Factory retornou:', retorno);

      if (!retorno || !retorno.transaction) {
        throw new Error('Factory não retornou dados válidos');
      }

      if (!retorno.file_manager_contract_id && file_manager_contract_id) {
        retorno.file_manager_contract_id = file_manager_contract_id;
      }

      console.log('📤 Atualizando JSON response do contrato...');
      await atualizarJsonResponseContract(
        retorno.file_manager_contract_id,
        retorno,
        retorno.contratoAddress,
        retorno.contratoClienteAddress,
        retorno.signerGeral,
        retorno.signature,
        retorno.hashedMessage
      );

      console.log('💾 Salvando dados em data2...');
      await atualizarData2Contract(retorno);

      console.log('🔄 Recarregando tela...');
      await recarregarTela(modelo_GUID, headers, project_id, setData2);

      console.log('🔄 Recarregando informações do contrato...');
      await recarregarContract(
        project_id,
        headers,
        setFileManagerContract,
        setContractAddressDeploy,
        setContractAddressClient,
        setContractWalletOwner,
        setContractProjectName,
        setContractProjectOwner,
        setContractCar,
        setContractCnpjCpf
      );

      // Mostrar mensagem de sucesso
      const successMessage = carCodes.length > 0 
        ? `Smart Contract gerado com sucesso!<br><br><strong>${carCodes.length} código(s) CAR incluído(s):</strong><br>${carCodes.join('<br>')}`
        : 'Smart Contract gerado com sucesso! (sem código CAR)';
      
      Swal.fire({
        title: 'Sucesso!',
        html: successMessage,
        icon: 'success',
        confirmButtonText: 'OK',
        width: '600px'
      });

      return true;

    } catch (error) {
      console.error('❌ Erro ao criar o contrato com Factory:', error);
      console.error('Stack trace:', error.stack);
      
      let errorMessage = 'Algo deu errado ao tentar criar o contrato.';
      const rawMessage = error?.message || error?.mensagem || '';

      if (rawMessage.includes('gas required exceeds allowance') || rawMessage.includes('out of gas')) {
        errorMessage = 'Erro de gas na transação. Aumente o limite de gas na MetaMask.';
      } else if (rawMessage.includes('insufficient funds')) {
        errorMessage = 'Saldo insuficiente na carteira para pagar as taxas de transação.';
      } else if (rawMessage.includes('User denied transaction')) {
        errorMessage = 'Transação rejeitada pelo usuário na MetaMask.';
      } else if (rawMessage.includes('Invalid signature')) {
        errorMessage = 'Assinatura inválida. Verifique os dados do contrato.';
      } else if (rawMessage) {
        errorMessage = rawMessage;
      }
      
      if (file_manager_contract_id) {
        console.log('⚠️ Atualizando campo de erro do contrato...');
        try {
          await atualizaCampoErroContract(
            file_manager_contract_id, 
            error.signer || '', 
            error.signature || '', 
            error.hashedMessage || '', 
            JSON.stringify({
              message: rawMessage,
              stack: error.stack,
              timestamp: new Date().toISOString()
            })
          );
        } catch (updateError) {
          console.error('❌ Erro ao atualizar campo de erro:', updateError);
        }
      }

      Swal.fire({
        title: 'Erro no Factory!',
        html: `
          <div style="text-align: left;">
            <p><strong>${errorMessage}</strong></p>
            ${carCodes.length > 0 ? `<p><strong>Códigos CAR tentados:</strong> ${carCodes.join(', ')}</p>` : ''}
            <p>Verifique a MetaMask ou contate o suporte.</p>
          </div>
        `,
        icon: 'error',
        confirmButtonText: 'OK',
        width: '600px'
      });
      return false;
    }

  } catch (error) {
    console.error('❌ Erro inesperado em criarContract:', error);
    console.error('Stack trace:', error.stack);
    
      Swal.fire({
        title: 'Erro inesperado!',
        text: 'Ocorreu um erro inesperado ao criar o contrato: ' + (error?.message || error?.mensagem || 'Erro desconhecido'),
      icon: 'error',
      confirmButtonText: 'OK',
    });
    return false;
  }
};